var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4987 19.8333V19.3333H6.9987H4.66536C3.65817 19.3333 2.83203 18.5072 2.83203 17.5V12.8333C2.83203 11.1728 4.17151 9.83333 5.83203 9.83333H22.1654C23.8259 9.83333 25.1654 11.1728 25.1654 12.8333V17.5C25.1654 18.5072 24.3392 19.3333 23.332 19.3333H20.9987H20.4987V19.8333V22.1667C20.4987 23.1739 19.6726 24 18.6654 24H9.33203C8.32484 24 7.4987 23.1739 7.4987 22.1667V19.8333ZM9.33203 15.8333H8.83203V16.3333V21C8.83203 21.9178 9.58089 22.6667 10.4987 22.6667H17.4987C18.4165 22.6667 19.1654 21.9178 19.1654 21V16.3333V15.8333H18.6654H9.33203ZM20.4987 12.8333C20.4987 13.7511 21.2476 14.5 22.1654 14.5C23.0832 14.5 23.832 13.7511 23.832 12.8333C23.832 11.9155 23.0832 11.1667 22.1654 11.1667C21.2476 11.1667 20.4987 11.9155 20.4987 12.8333ZM8.16537 4H19.832C20.1976 4 20.4987 4.30114 20.4987 4.66667V7C20.4987 7.36552 20.1976 7.66667 19.832 7.66667H8.16537C7.79984 7.66667 7.4987 7.36552 7.4987 7V4.66667C7.4987 4.30114 7.79984 4 8.16537 4Z",
    fill: "#52509A",
    stroke: "#52509A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.c844c435ccbdbaf02bedf806f49989f7.svg";
export { ForwardRef as ReactComponent };